import { useContext, ReactNode } from 'react';

import { NsCta } from 'components/common/ns-cta/NsCta';
import { FormContext } from 'components/common/ns-form/context/FormContext';
import { NsIconProps } from 'components/common/ns-icon/NsIcon';

type NsPrimaryCtaProps = {
  type?: 'direct' | 'text' | 'submit';
  onClick?: (event: React.MouseEvent | React.KeyboardEvent) => void;
  isLoading?: boolean;
  href?: React.AnchorHTMLAttributes<HTMLAnchorElement>['href'];
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>['target'];
  rel?: React.AnchorHTMLAttributes<HTMLAnchorElement>['rel'];
  children?: ReactNode;
  loadingMessage?: string;
  icon?: NsIconProps['type'];
  testId?: string;
};

export const NsPrimaryCta = (props: NsPrimaryCtaProps) => {
  const usedInForm = useContext(FormContext);
  const { children, ...rest } = props;
  const type = usedInForm ? 'submit' : 'direct';

  return (
    <NsCta type={type} {...rest}>
      {children}
    </NsCta>
  );
};
